import React from 'react'
import PropTypes from 'prop-types'
import { Formik as RealFormik } from 'formik'

function Formik({ children, formProps, ...props }) {
  return (
    <RealFormik {...props}>
      {fkProps => (
        <form
          {...formProps}
          onSubmit={e => {
            e.preventDefault()
            fkProps.handleSubmit(e)
          }}
        >
          {children(fkProps)}
        </form>
      )}
    </RealFormik>
  )
}

Formik.propTypes = {
  ...RealFormik.propTypes,
  formProps: PropTypes.object,
}

export default Formik